import { render, staticRenderFns } from "./AttributeEditor.vue?vue&type=template&id=08ea8f9c&scoped=true&"
import script from "./AttributeEditor.vue?vue&type=script&lang=js&"
export * from "./AttributeEditor.vue?vue&type=script&lang=js&"
import style0 from "./AttributeEditor.vue?vue&type=style&index=0&id=08ea8f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea8f9c",
  null
  
)

export default component.exports